import classNames from 'clsx'
import { bool, node } from 'prop-types'

import { productLabelType } from 'views/utils/propTypes'

import './Flag.scss'

const Flag = ({
  label,
  prescription,
  children,
  withIcon,
  nowWidget,
  smaller,
  redPointsMultiplier,
  nowLabelGray,
  discount,
}) => {
  const flagClassname = classNames('a-Flag', {
    'a-Flag--prescription': prescription,
    'a-Flag--nowWidget': nowWidget,
    'a-Flag--smaller': smaller,
    'a-Flag--with-icon': withIcon,
    'a-Flag--redPointsMultiplier': redPointsMultiplier,
    'a-Flag--nowLabelGrey': nowLabelGray,
    'a-Flag--discount': discount,
  })

  return (
    <span className="u-display--inline-block">
      <span className={flagClassname}>
        {label}
        {children}
      </span>
    </span>
  )
}

Flag.propTypes = {
  children: node,
  label: productLabelType.isRequired,
  prescription: bool,
  nowWidget: bool,
  withIcon: bool,
  smaller: bool,
  redPointsMultiplier: bool,
  nowLabelGray: bool,
  discount: bool,
}

Flag.defaultProps = {
  children: null,
  prescription: null,
  nowWidget: null,
  withIcon: false,
  smaller: false,
  redPointsMultiplier: false,
  nowLabelGray: false,
  discount: false,
}

export default Flag
